function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.541176 0 0 0 0 0.686275 0 0 0 0 0.976471 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Hosting-Sign-up",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hosting-Registration-/-Instances-/-Default",
  transform: "translate(-110.000000, -767.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hosting-/-Contact-From",
  transform: "translate(70.000000, 488.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(32.000000, 237.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Input-Container/Icon-Left",
  transform: "translate(0.000000, 34.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "opening-times",
  transform: "translate(8.000000, 8.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.800000, 4.800000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#AEB9BE",
  strokeWidth: 1.2,
  strokeLinecap: "square",
  cx: 10.56,
  cy: 11.04,
  r: 3.36
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#AEB9BE",
  strokeWidth: 1.2,
  strokeLinecap: "square",
  points: "10.56 9.6 10.56 11.04 12 11.04"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.84,
  y1: 0,
  x2: 3.84,
  y2: 1.92,
  id: "Path",
  stroke: "#AEB9BE",
  strokeWidth: 1.2,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.56,
  y1: 0,
  x2: 10.56,
  y2: 1.92,
  id: "Path",
  stroke: "#AEB9BE",
  strokeWidth: 1.2,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.4,
  y1: 4.8,
  x2: 0,
  y2: 4.8,
  id: "Path",
  stroke: "#AEB9BE",
  strokeWidth: 1.2
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#AEB9BE",
  strokeWidth: 1.2,
  strokeLinecap: "square",
  points: "5.28 13.44 0 13.44 0 1.92 14.4 1.92 14.4 6.72"
}))))))));

const SvgCalendar = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.dce84ce3.svg";
export { ForwardRef as ReactComponent };